import Swiper, { Lazy, Navigation, Pagination, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/lazy';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initializeSliderBooks(containerId) {
    const containerSlider = $(containerId);

    const swiperRecipe = new Swiper(containerId + ' .swiper-no-padding ', {
        modules: [Navigation, Pagination, Lazy, Scrollbar],

        centeredSlides: true, // Garante que o slide fique centralizado
        slidesPerView: 1, // Exibir apenas 1 slide por vez
        spaceBetween: 24, // Remove espaçamento extra no mobile
    

        breakpoints: {
            //md
            768: {
                centeredSlides: false,
                spaceBetween: 24,
                slidesPerView: 'auto',
            },
        },

        pagination: {
            el: containerId + ' .swiper-pagination',
            type: 'progressbar',
        },

        lazy: {
            enabled: true,
            loadPrevNext: true,
            loadPrevNextAmount: 4,
        },

        navigation: {
            prevEl: containerId + ' .btn-prev',
            nextEl: containerId + ' .btn-next',
        },
    });

    swiperRecipe.on('slideChange', function () {
        // containerSlider.find('.slider-current-page').html((this.realIndex + 1).toString().padStart(2, '0'));
        containerSlider.find('.slider-current-page').html('01');
        containerSlider.find('.slider-progress .progress-fill').css('width', Math.min(this.progress * 100, 100) + '%');
    });
}

$(function () {
    $('.slider-about-card').each(function () {
        initializeSliderBooks('#' + $(this).attr('id'));
    });
});
